import { Box, useColorModeValue } from "@chakra-ui/react";

// Функция обертки для использования везде
function PriceWrapper({ children }) {
	const borderColor = useColorModeValue('gray.200', 'gray.500');
	const bgColor = useColorModeValue('gray.50', 'gray.700');

	return (
		<Box
			mb={4}
			shadow="base"
			borderWidth="1px"
			borderColor={borderColor}
			borderRadius={'xl'}
			flex="1"
			maxWidth="350px" // Установите максимальную ширину для больших экранов
			width="100%" // Установите ширину на 100% для мобильных устройств
			bg={bgColor} // Фоновый цвет
		>
			{children}
		</Box>
	);
}

export default PriceWrapper;